module.exports = __webpack_public_path__ + "img/Bitexbook.ead7fdc8.png";